import React from 'react';
import Utils from '../../providers/Utils';
import { Fab, Button, Grid, Avatar } from '@material-ui/core';
import PropTypes from 'prop-types'

import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';

export default class GanttProiecteCreateEtapeView extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            drawSvg: []
        }
    }

    ws = new Ws()

    componentDidMount() {
        // this.listSvg()

    }

    goToEtapa = (e) => {

        if (this.props.displayHead === 1) {
            this.props.changeView(false, e)
        } else {

            this.props.changeView(false, e)
        }

    }



    arataData = (d) => {

        let u = new Utils();

        if (this.props.dictionary.date === 'en') {
            return u.dataPrescurtataEngNoYear(u.ParseDataFromSql(d))
        } else {
            return u.dataPrescurtataRomanaNoYear(u.ParseDataFromSql(d))
        }


    }







  

    getDate = (dt) => {

        let u = new Utils();
    
        if (this.props.dictionary.date === ' en') {
          return u.dataPrescurtataEng(dt)
        } else {
          return u.dataPrescurtataRomana(dt)
        }
      }




    listBody = () => {

        let listEtape = this.props.listEtape

        // console.warn('this.props.listEtape :', this.props.listEtape);


        let cloneTaskuri = this.props.listTaskuri

        // console.log('listEtape', listEtape)

        let u = new Utils()
        let objInfo = this.props.objProiectInfo

        //  console.log('objInfo :', objInfo);

        let dataStart = new Date(u.ParseDataFromSql(objInfo[0].perioada_dela))

        let dataFinish = new Date(u.ParseDataFromSql(objInfo[0].perioada_panala))

        let counter = listEtape.length

        let container = []

        let marginEtapa = 0

        let full = dataFinish.getTime() - dataStart.getTime()

        let defaultDate = new Date()

        let procent = 0

        let taskuriList = []

        let listSubtaskuri = []

        let screenSize = (window.innerWidth * 98) / 100

        //   console.log('screenSize ----------------------:', screenSize);

        for (let i = 0; i < counter; i++) {


            let dataSfEtapa = new Date(listEtape[i].durata_pana_la)

            let dataStartEtapa = new Date(listEtape[i].durata_de_la)


            let suma = dataSfEtapa.getTime() - dataStart.getTime()

            let newProcent = Math.floor((suma / full) * 100)




            if (i === counter - 1) {

                // console.log('newProcent :', newProcent);

                newProcent = 100
            }


            if (i > 0) {
                if (new Date(listEtape[i - 1].durata_pana_la) > new Date(listEtape[i].durata_de_la)) {
                    listEtape[i].zigZag = true
                } else {
                    listEtape[i].zigZag = false
                }
            } else {
                listEtape[i].zigZag = false
            }

            listEtape[i].procent = newProcent - procent
            listEtape[i].left = procent
            listEtape[i].x = (screenSize * (procent + (listEtape[i].procent / 2))) / 100
            listEtape[i].offsetWidth = (screenSize * (procent + listEtape[i].procent)) / 100
            listEtape[i].clientWidth = screenSize * (listEtape[i].procent) / 100
            listEtape[i].clientLeft = listEtape[i].offsetWidth - listEtape[i].clientWidth

            procent = newProcent

            let taskuriFilter = cloneTaskuri.filter(t => t.id_etapa_proiect === listEtape[i].id)

            taskuriFilter = taskuriFilter.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(listEtape[i].durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(listEtape[i].durata_pana_la)))

            // console.warn('taskuri filter', taskuriFilter)
            let taskuriBottom = -30

            let counter2 = taskuriFilter.length



            for (let j = 0; j < counter2; j++) {
                let dataSfTask = new Date(u.ParseDataFromSql(taskuriFilter[j].pana_cand_data))
                let dataInceputTask = new Date(u.ParseDataFromSql(taskuriFilter[j].cand_data))
                // console.log('dataSfTask :', dataSfTask);
                // console.log('dataSfEtapa :', dataSfEtapa);

                let sumaEtapa = dataSfEtapa.getTime() - dataStartEtapa.getTime()

                let sumaTask = dataSfTask.getTime() - dataInceputTask.getTime()

                let newMargin = dataInceputTask.getTime() - dataStartEtapa.getTime()

                let procentTask = Math.floor((newMargin / sumaEtapa) * 100)


                taskuriFilter[j].marginLeft = procentTask

                if (j === 0) {
                    // console.log('newMargin :', newMargin);
                    // console.log('procentTask :', procentTask);
                }



                let newProcentTask = Math.floor((sumaTask / sumaEtapa) * 100)

                // console.log('newProcentTask :', newProcentTask);

                taskuriFilter[j].procent = newProcentTask

                taskuriFilter[j].left = (((taskuriFilter[j].marginLeft + (taskuriFilter[j].procent / 2)) * listEtape[i].clientWidth) / 100) + listEtape[i].clientLeft

                taskuriFilter[j].subtskLeft = ((taskuriFilter[j].marginLeft + (taskuriFilter[j].procent / 2)) * listEtape[i].clientWidth) / 100

                taskuriFilter[j].clientWidth = listEtape[i].clientWidth * (taskuriFilter[j].procent) / 100

                taskuriFilter[j].clientLeft = (taskuriFilter[j].marginLeft * listEtape[i].clientWidth) / 100

                // console.log('procentTask :', procentTask);

                let procentFilter = taskuriFilter.filter(t => t.id !== taskuriFilter[j].id)

                procentFilter = procentFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) > new Date(u.ParseDataFromSql(taskuriFilter[j].cand_data)))

                // console.log('procentFilter :', procentFilter);





                if (procentFilter.length > 0) {
                    // console.log('dataDupa :',);

                    taskuriBottom += -30

                } else {
                    taskuriBottom = -30
                }

                taskuriFilter[j].bottom = taskuriBottom


                // console.log('bottom --- ----- ---- --- - :', - taskuriFilter[j].bottom);

                let ipo = Math.sqrt(Math.pow((listEtape[i].x - taskuriFilter[j].left), 2) + Math.pow(-taskuriFilter[j].bottom, 2))

                // console.log('ipo!!!!!!!!------!!!! :', ipo);


                taskuriFilter[j].degree = - ((listEtape[i].x - taskuriFilter[j].left) / ipo) * (180 / 3.14)


                let subtaskuri = this.props.listSubTaskuri


                let filterSubtaskuri = subtaskuri.filter(t => t.id_task_parent === taskuriFilter[j].id)

                // console.log('filterSubtaskuri :', filterSubtaskuri);


                filterSubtaskuri = filterSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(taskuriFilter[j].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(taskuriFilter[j].pana_cand_data))))

                // console.log('filterSubtaskuri :', filterSubtaskuri);

                let counter3 = filterSubtaskuri.length

                let subTaskuriBottom = -30

                for (let k = 0; k < counter3; k++) {
                    let dataSfSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[k].pana_cand_data))
                    let dataInceputSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[k].cand_data))



                    let sumaSubTask = dataSfSubTask.getTime() - dataInceputSubTask.getTime()

                    let newMarginSubtask = dataInceputSubTask.getTime() - dataInceputTask.getTime()


                    let procentSubtask = Math.floor((newMarginSubtask / sumaTask) * 100)

                    filterSubtaskuri[k].marginLeft = procentSubtask

                    let newProcentSubtask = Math.floor((sumaSubTask / sumaTask) * 100)

                    filterSubtaskuri[k].procent = newProcentSubtask

                    filterSubtaskuri[k].left = ((filterSubtaskuri[k].marginLeft + (filterSubtaskuri[k].procent / 2)) * taskuriFilter[j].clientWidth) / 100 + taskuriFilter[j].clientLeft


                    filterSubtaskuri[k].clientWidth = taskuriFilter[j].clientWidth * (filterSubtaskuri[k].procent) / 100

                    filterSubtaskuri[k].clientLeft = (filterSubtaskuri[k].marginLeft * taskuriFilter[j].clientWidth) / 100

                    let subTaskProcFilter = filterSubtaskuri.filter(t => t.id !== filterSubtaskuri[k].id)
                    subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubtaskuri[k].cand_data)))

                    // console.log('subTaskProcFilter :', subTaskProcFilter);



                    if (subTaskProcFilter.length > 0) {




                        taskuriBottom += -30

                        subTaskuriBottom = -30 * (k + 1)

                    } else {
                        subTaskuriBottom = -30

                    }
                    // console.log('taskuriBottom :', taskuriBottom);

                    filterSubtaskuri[k].bottom = subTaskuriBottom

                    let ipo = Math.sqrt(Math.pow((taskuriFilter[j].subtskLeft - filterSubtaskuri[k].left), 2) + Math.pow(-filterSubtaskuri[k].bottom, 2))

                    filterSubtaskuri[k].degree = -((taskuriFilter[j].subtskLeft - filterSubtaskuri[k].left) / ipo) * (180 / 3.14)

                    listSubtaskuri.push(filterSubtaskuri[k])

                    let subSubtaskuri = this.props.listSubTaskuri

                    // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                    let filterSubSubtaskuri = subSubtaskuri.filter(t => t.id_task_parent === filterSubtaskuri[k].id)

                    // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                    filterSubSubtaskuri = filterSubSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubtaskuri[k].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(filterSubtaskuri[k].pana_cand_data))))



                    let counter4 = filterSubSubtaskuri.length

                    let subTaskuriBottom1 = -30

                    for (let q = 0; q < counter4; q++) {
                        let dataSfSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].pana_cand_data))
                        let dataInceputSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data))



                        let sumaSubTask1 = dataSfSubTask1.getTime() - dataInceputSubTask1.getTime()

                        let newMarginSubtask1 = dataInceputSubTask1.getTime() - dataInceputSubTask.getTime()


                        let procentSubtask1 = Math.floor((newMarginSubtask1 / sumaTask) * 100)

                        filterSubSubtaskuri[q].marginLeft = procentSubtask1

                        let newprocentSubtask1 = Math.floor((sumaSubTask / sumaTask) * 100)

                        filterSubSubtaskuri[q].procent = newprocentSubtask1

                        filterSubSubtaskuri[q].left = ((filterSubSubtaskuri[q].marginLeft + (filterSubSubtaskuri[q].procent / 2)) * filterSubtaskuri[k].clientWidth) / 100 + filterSubtaskuri[k].clientLeft


                        filterSubSubtaskuri[q].clientWidth = filterSubtaskuri[k].clientWidth * (filterSubSubtaskuri[q].procent) / 100

                        filterSubSubtaskuri[q].clientLeft = (filterSubSubtaskuri[q].marginLeft * filterSubtaskuri[k].clientWidth) / 100

                        let subTaskProcFilter = filterSubSubtaskuri.filter(t => t.id !== filterSubSubtaskuri[q].id)
                        subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data)))

                        // console.log('subTaskProcFilter :', subTaskProcFilter);



                        if (subTaskProcFilter.length > 0) {




                            taskuriBottom += -30

                            subTaskuriBottom += -30

                            subTaskuriBottom1 = -30 * (q + 1)

                        } else {
                            subTaskuriBottom = -30

                            subTaskuriBottom1 = -30

                        }
                        // console.log('taskuriBottom :', taskuriBottom);

                        filterSubSubtaskuri[q].bottom = subTaskuriBottom

                        let ipo = Math.sqrt(Math.pow((filterSubtaskuri[k].left - filterSubSubtaskuri[q].left), 2) + Math.pow(-filterSubSubtaskuri[q].bottom, 2))

                        filterSubSubtaskuri[q].degree = -((filterSubtaskuri[k].left - filterSubSubtaskuri[q].left) / ipo) * (180 / 3.14)

                        listSubtaskuri.push(filterSubSubtaskuri[q])

                    }

                }
            }





            // console.warn('finalTaskuriFilter :', cloneTaskuri);

        }




        // console.log('dataFinish :', dataFinish);


        // console.log('listEtape :', listEtape);


        container =
            <div style={{ width: '100%', height: '100%', marginTop: 30 }}>



                <div style={{ width: `98%`, height: 50, boxSizing: 'border-box', margin: 'auto', position: 'relative', textAlign: 'left', display:'flex' }}>
                    {listEtape.map((e, idxE) => {
                        return (
                            <div onClick={() => { this.goToEtapa(e) }} id={`pm-etapa-proiect-integral${e.id}`}
                                className={`pm-proiect-integral-etapa ${this.props.idEtapa === e.id ? 'pm-selected-project-shadow' : ''}`}
                                key={`etapa${idxE}`}
                                onMouseEnter={() => { this.props.showTag(e) }}
                                onMouseLeave={() => { this.props.hideTag(e) }}
                                style={{
                                    boxSizing: 'border-box',
                                    marginLeft: `${marginEtapa}%`,
                                    position: 'relative',
                                    minWidth:40,
                                    width: e.procent + '%',
                                    backgroundColor: 'rgb(79 79 79 / 34%)',

                                    borderRight: idxE === listEtape.length - 1 ? '' : '1px solid #f3ebeb',
                                    borderBottomLeftRadius: idxE === 0 ? 30 : 0,
                                    borderTopLeftRadius: idxE === 0 ? 30 : 0,
                                    borderBottomRightRadius: idxE === listEtape.length - 1 ? 30 : 0,
                                    borderTopRightRadius: idxE === listEtape.length - 1 ? 30 : 0,
                                    boxShadow: e.zigZag ? `-19px 0px 9px -3px rgba(0,0,0,0.75)` : ''
                                }}>

                                {/* <div  style={{display:e.zigZag ? 'block' : 'none', height:50, width:50, backgroundImage:`url('${ZigZag}')` }}></div> */}
                                {/* <div style={{
                                    display: e.zigZag ? 'block' : 'none',
                                    position: 'absolute',
                                    left: -10,
                                    top: 0,
                                    width: 10,
                                    height: '100%',

                                    background: `linear-gradient(45deg, transparent 40.333% , 
                                                                        ${e.color} 40.333%, ${e.color} 66.667%,
                                                                        transparent 66.667% ),
                                                          linear-gradient(135deg, transparent 33.333%,
                                                                          ${e.color} 33.333%, ${e.color} 66.667%,
                                                                          transparent 66.667%)`,
                                    backgroundRepeat: 'repeat-y',
                                    backgroundPosition: 'left-top',
                                    backgroundSize: '24px 20px'
                                }}></div> */}

                                {/* <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                    <div style={{ position: 'relative' }}>

                                        <div className='etapa-tag' style={{ position: 'absolute', display: 'block', top: -5 }}>
                                            <div className='etapa-tag-container' style={{ position: 'relative' }}>


                                                <div style={{
                                                    position: 'absolute',
                                                    top: -11,
                                                    left: 20
                                                }} className='triangle-up'>

                                                </div>

                                                <h4 style={{ marginBottom: 5 }}>Stadiul {idxE + 1} - {e.denumire} </h4>
                                                <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>Durata:{new Utils().dataPrescurtataRomana(e.durata_de_la)} - {new Utils().dataPrescurtataRomana(e.durata_pana_la)} </span>
                                                <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>Grad de completare:{e.procent_completare}% </span>
                                                <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>Numar taskuri:{e.taskuri.length} </span>
                                                {e.taskuri_trecute > 0 && e.in_lucru &&
                                                    <span style={{ marginTop: 5, display: "block", fontSize: 14 }}><i style={{
                                                        color: 'white',
                                                        fontSize: 12,
                                                        backgroundColor: 'red',
                                                        borderRadius: '50%',
                                                        padding: 1,

                                                    }} className='material-icons'>priority_high</i> {e.taskuri_trecute} {e.taskuri_trecute > 1 ? 'Taskuri cu termen depasit' : 'Task cu termen depasit'}</span>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div> */}


                        

                                <div style={{ position: 'relative', width: 'fit-content', margin: 'auto' }}>
                                    <div className='etapa-tag' style={{
                                        position: 'absolute', display: e.show_tag ? 'block' : 'none', top: 30,
                                        left: -25
                                    }}>
                                        <div className='etapa-tag-container' style={{ position: 'relative' }}>


                                            <div style={{
                                                position: 'absolute',
                                                top: -11,
                                                left: 20
                                            }} className='triangle-up'>

                                            </div>

                                            <h4 style={{ marginBottom: 5 }}>Stadiul {idxE + 1} - {e.denumire} </h4>
                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.duration}:{new Utils().dataPrescurtataRomana(e.durata_de_la)} - {new Utils().dataPrescurtataRomana(e.durata_pana_la)} </span>
                                            {/* <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>Grad de completare:0% </span> */}
                                            {/* <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>Numar taskuri:{e.taskuri.length} </span> */}
                                            {e.taskuri_trecute > 0 && e.in_lucru &&
                                                <span style={{ marginTop: 5, display: "block", fontSize: 14 }}><i style={{
                                                    color: 'white',
                                                    fontSize: 12,
                                                    backgroundColor: 'red',
                                                    borderRadius: '50%',
                                                    padding: 1,

                                                }} className='material-icons'>priority_high</i> {e.taskuri_trecute} {e.taskuri_trecute > 1 ?    this.dictionary.proiecte.taskuriDepasite : this.dictionary.proiecte.taskDepasit}</span>
                                            }
                                        </div>

                                    </div>

                                    <span style={{ textAlign: 'center' }} className='pm-proiect-integral-etapa-nr' >{idxE + 1}</span>
                                </div>

                                {/* {cloneTaskuri.filter(ct => ct.id_etapa_proiect === e.id).map((t, idxT) => {

                                    return (
                                        <div onClick={() => { this.props.goToTask(t, e) }} className={`pm-task-proiect-integral ${this.props.idTask === t.id ? 'pm-selected-project-shadow' : ''}`} key={`taskuri${idxT}`} style={{
                                            width: `${t.procent}%`,

                                            bottom: t.bottom,
                                            left: `${t.marginLeft}%`,
                                            backgroundColor: t.color
                                        }}>
                                            <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span>
                                            <span className='pm-task-proiect-integral-titlu'>{t.titlu}</span>

                                            <div className='pm-task-etapa-line' style={{
                                                height: - t.bottom || 0,
                                                top: t.bottom || 0,
                                                transform: `skew(${t.degree}deg)`
                                            }}>

                                            </div>
                                            {listSubtaskuri.filter(st => st.id_task_parent === t.id).map((st, idxSt) => {
                                                return (
                                                    <div className={`pm-sub-task-integral ${this.props.idTask === st.id ? 'pm-selected-project-shadow' : ''}`} key={`subTaskuri${idxSt}`} style={{
                                                        width: `${st.procent}%`,

                                                        bottom: st.bottom,
                                                        left: `${st.marginLeft}%`,
                                                        backgroundColor: st.color
                                                    }}>
                                                        <span onClick={() => { this.props.goToTask(st) }} style={{ backgroundColor: st.color }} className='pm-sub-task-titlu'>{st.titlu}</span>

                                                        <div className='pm-task-etapa-line' style={{
                                                            height: - st.bottom || 0,
                                                            top: st.bottom || 0,
                                                            transform: `skew(${st.degree}deg)`
                                                        }}>

                                                        </div>

                                                        {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt) => {
                                                            return (
                                                                <div className={`pm-sub-task-integral ${this.props.idTask === sst.id ? 'pm-selected-project-shadow' : ''}`} key={`subTaskuri${idxSSt}`} style={{
                                                                    width: `${sst.procent}%`,

                                                                    bottom: sst.bottom,
                                                                    left: `${sst.marginLeft}%`,
                                                                    backgroundColor: sst.color
                                                                }}>
                                                                    <span onClick={() => { this.props.goToTask(sst) }} style={{ backgroundColor: sst.color }} className='pm-sub-task-titlu'>{sst.titlu}</span>

                                                                    <div className='pm-task-etapa-line' style={{
                                                                        height: - sst.bottom || 0,
                                                                        top: sst.bottom || 0,
                                                                        transform: `skew(${sst.degree}deg)`
                                                                    }}>

                                                                    </div>
                                                                </div>
                                                            )


                                                        })}
                                                    </div>
                                                )


                                            })}
                                        </div>
                                    )
                                })} */}
                            </div>
                        )

                    })}

                </div>






            </div>


        //   this.setState({listaSvgLines: listaSvgLines})

        return container
    }

    render() {
        return (
            <div style={{ width: '100%', position: 'relative', backgroundColor: 'white', padding: 20 }}>

                {/* <span className='pm-title'>Perioada Proiect</span> */}
                <span style={{ position: 'absolute', fontSize: 13, color: 'black', top: 30, left:0 }}>{this.getDate(this.props.objProiectInfo[0].perioada_dela)}</span>
                  <span style={{ position: 'absolute', fontSize: 13, color: 'black', top: 30, right: 0 }}>{this.getDate(this.props.objProiectInfo[0].perioada_panala)}</span>

                {/* <div style={{textAlign:'center', marginBottom:20, padding:15}}>
              
                    <Button style={{display:this.props.displayInsert === 1 ? 'none' : 'inline-flex',padding:16, backgroundColor:'#07bd07', color:'white',fontSize:22, fontWeight:500}} onClick={this.props.insertEtapa}  >
                        <i className='material-icons pm-round-button-text'>add</i>
                        Adauga Etapa
                    </Button>
                    </div> */}


                {/* <h3 style={{ cursor: this.props.displayHead === 1 ? 'default' : 'pointer' }} onClick={() => { this.props.changeView(true) }} className='pm-title'>{this.props.objProiectInfo[0].titlu}</h3> */}

                <div style={{ position: 'relative', marginTop: 50 }}>
                    {this.listBody()}
                    {/* <svg style={{position:'absolute', width:'100vw', height:'50vh', left:0, top:0}}>
                {this.state.drawSvg}
              </svg> */}
                </div>

               

                <div>


                </div>
            </div>
        );
    }
}//end class


GanttProiecteCreateEtapeView.propType = {
    objProiectInfo: PropTypes.object,
    dictionary: PropTypes.object,
    listEtape: PropTypes.array,
    screenLimit: PropTypes.number,
    listTaskuri: PropTypes.array,
    changeView: PropTypes.func,
    goToTask: PropTypes.func,
    insertEtapa: PropTypes.func,
    listSubTaskuri: PropTypes.array
}